import { z } from 'zod';
import { twentyThreeAudioSchema } from '../schema.twenty-three-audio.js';
import { bindInputMaker } from '../util.make-input.js';

const baseSchema = z.object({
  fixed: z.boolean().default(false)
});
const audioSchema = baseSchema.extend({
  type: z.literal("Audio"),
  title: z.string(),
  src: z.string().nullish().default(null),
  twentyThreeAudio: twentyThreeAudioSchema
}).transform(({
  twentyThreeAudio,
  ...rest
}) => ({
  ...rest,
  src: twentyThreeAudio?.src || rest.src || ""
}));
const imageSchema = baseSchema.extend({
  type: z.literal("Image"),
  title: z.string(),
  src: z.string(),
  audioSrc: z.string().nullable().default(null),
  altText: z.string().nullable().default(null),
  twentyThreeAudio: twentyThreeAudioSchema
}).transform(({
  twentyThreeAudio,
  ...rest
}) => ({
  ...rest,
  audioSrc: twentyThreeAudio?.src || rest.audioSrc
}));
const textSchema = baseSchema.extend({
  type: z.literal("Text"),
  text: z.string()
});
const makeInput = bindInputMaker();
const sequenceTileInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("sequence-tile").default("sequence-tile"),
      index: z.number().default(0)
    }),
    shouldValidate: node => !node.options.fixed,
    validate: (node, entry) => node.validation.expectedIndices.includes(entry.index),
    parseLegacyDetailItem: (item, context) => {
      if (["Sequence"].includes(context.relatedTask.taskType) && ["Horizontal", "Vertical", "Circuit"].includes(context.relatedTask.answerType ?? "") && typeof item === "number") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "sequence-tile",
          index: item
        }];
      }
    }
  },
  schema: z.discriminatedUnion("type", [audioSchema, imageSchema, textSchema]),
  postprocessSchemaInput: (input, context) => {
    // NB: All positions that includes the text of the current input should be
    // considered valid when validating.
    const validIndices = context.arr.map((it, index) => ({
      ...it,
      index
    })).filter(it => {
      if (it.fixed) {
        return false;
      }
      switch (true) {
        case it.type === "Audio" && input.type === "Audio":
          return it.src === input.src && it.title === input.title;
        case it.type === "Image" && input.type === "Image":
          return it.src === input.src && it.title === input.title;
        case it.type === "Text" && input.type === "Text":
          return it.text === input.text;
        default:
          return false;
      }
    }).map(it => it.index);
    return {
      ...input,
      id: `${context.taskId}-${context.index}`,
      nodeType: "sequence-tile-input",
      options: {
        fixed: input.fixed
      },
      validation: {
        expectedIndices: validIndices
      }
    };
  }
});

export { sequenceTileInput };
//# sourceMappingURL=input.tile.js.map
